import React, { useState } from 'react'
import { useActivity } from 'contexts/activities'
import classNames from 'classnames'
import { Power } from '@phosphor-icons/react'
import { useUser } from 'contexts/user'

export default function Header() {

    const { activity, activities, changeActivity } = useActivity()
    const { logout } = useUser();
    const [dropdown, setDropdown] = useState(false)

    const DropdownClasses = classNames({
        'absolute right-0 top-10 bg-white p-4 rounded-xl w-300 border border-line shadow-md': true,
        'hidden': !dropdown
    })

    return (
        <div className='w-full md:w-header absolute h-header top-0 left-0 md:left-60 z-200 py-4 px-5 bg-white drop-shadow-header'>
            <div className='flex justify-end'>
                <div className='flex-1 md:hidden'>
                    <a href="/" className='py-4'>
                        <img src={"/images/logo.png"} className="h-9 w-auto" title="Parkagent" alt="Parkagent"/>
                    </a>
                </div>
                <div className='relative flex items-center cursor-pointer' onClick={() => setDropdown(!dropdown)}>
                    <div className="hidden md:block pr-2 text-xs">{activity?.name || 'Benvenuto'}</div>
                    <div className='h-8 w-8 rounded-full bg-white border border-line bg-center bg-cover' style={{backgroundImage: `url(/images/avatar.jpg)`}}></div>

                    <div className={DropdownClasses}>
                        <div className='flex items-center justify-between'>
                            <div className="text-sm text-gray">Le tue attività</div>

                            <div className='group h-8 w-8 rounded-full border border-line flex items-center justify-center hover:bg-red hover:border-red cursor-pointer' title="Esci" onClick={logout}>
                                <Power className='fill-black group-hover:fill-white h-5 w-5' weight="bold" />
                            </div>
                        </div>

                        <div className='pt-2'>
                            {activities?.map(activity => (
                                <div className='block py-1 border-b border-line last:border-0 cursor-pointer hover:text-primary' key={activity._id} onClick={() => changeActivity(activity._id)}>{activity.name}</div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
